export default {
  inserted: function (el: Element) {
    if (el.className.indexOf("cus_wrapper") === -1) {
      el.className = el.className + " cus_wrapper";
    }
    // console.log(el.scrollWidth, el.clientWidth, el.innerText);

    if (el.querySelector(".cus-animation")) {
      return;
    }
    setTimeout(() => {
      if (el.scrollWidth > el.clientWidth) {
        const span: Element = document.createElement("span");
        span.className = "cus-animation";
        (span as any).style.animationDuration =
          Math.ceil(el.scrollWidth / 100) + "s";
        span.innerHTML =
          el.innerHTML +
          '<div style="display: inline-block;width: 48px;"></div>' +
          el.innerHTML +
          '<div style="display: inline-block;width: 48px;"></div>';
        el.innerHTML = span.outerHTML;
      }
    });
  },
  componentUpdated: function (el: Element) {
    if (el.className.indexOf("cus_wrapper") === -1) {
      el.className = el.className + " cus_wrapper";
    }
    if (el.querySelector(".cus-animation")) {
      return;
    }
  },
};
